import React, { useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { scaleLinear } from "d3-scale";

const GEO_URL = "/india-states-topo.json";

export default function IndiaHeatmap({ data = [] }) {
  const [tip, setTip] = useState(null);
  const byState = Object.fromEntries(data.map((d) => [d.state, d]));
  const max = Math.max(1, ...data.map((d) => d.value));
  const color = scaleLinear().domain([0, max]).range(["#EEF2FF", "#4338CA"]);

  return (
    <div className="relative">
      <ComposableMap projection="geoMercator" projectionConfig={{ scale: 900, center: [82, 22] }} width={520} height={520} style={{ width: "100%", height: "auto" }}>
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const name = geo.properties.st_nm;
              const d = byState[name];
              const fill = d ? color(d.value) : "#F1F5F9";
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={fill}
                  stroke="#fff"
                  strokeWidth={0.5}
                  onMouseEnter={() => setTip(d ? `${name}: ${d.value} leads · ${d.hot} hot` : `${name}: 0 leads`)}
                  onMouseLeave={() => setTip(null)}
                  style={{
                    default: { outline: "none" },
                    hover: { fill: "#6366F1", outline: "none", cursor: "pointer" },
                    pressed: { outline: "none" },
                  }}
                  data-testid={`state-${name}`}
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>
      {tip && <div className="absolute top-2 left-2 bg-slate-900 text-white text-xs px-2 py-1 rounded-md shadow-lg" data-testid="map-tooltip">{tip}</div>}
      <div className="flex items-center gap-2 justify-center mt-2 text-xs text-slate-400">
        <span>Fewer</span>
        <div className="h-2 w-24 rounded-full" style={{ background: "linear-gradient(to right, #EEF2FF, #4338CA)" }} />
        <span>More hot leads</span>
      </div>
    </div>
  );
}
